// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  AttemptStatus,
} from "./types";


export default __t.row({
  attemptId: __t.u64().primaryKey().name("attempt_id"),
  assignmentId: __t.u64().name("assignment_id"),
  attemptNumber: __t.u32().name("attempt_number"),
  sessionId: __t.u64().name("session_id"),
  get status() {
    return AttemptStatus;
  },
  startedAt: __t.option(__t.timestamp()).name("started_at"),
  endedAt: __t.option(__t.timestamp()).name("ended_at"),
  scorePct: __t.option(__t.u32()).name("score_pct"),
  passed: __t.option(__t.bool()),
});
